module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.props) ? _c('div', {
    staticClass: "event-modal"
  }, [_c('div', {
    staticClass: "event-modal__overlay",
    on: {
      "click": function($event) {
        return _vm.closeModal(2)
      }
    }
  }), _c('div', {
    staticClass: "event-modal__container"
  }, [_c('div', {
    staticClass: "event-modal__close",
    on: {
      "click": function($event) {
        return _vm.closeModal(2)
      }
    }
  }, [_c('span'), _c('span')]), _c('div', {
    staticClass: "event-modal__content"
  }, [_c('div', {
    staticClass: "event-modal__text",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.event_modal.content)
    }
  }), _c('div', {
    staticClass: "event-modal__form-container"
  }, [_c('EventForm')], 1), _c('div', {
    staticClass: "event-modal__spacer"
  })])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2764d29e","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/modal/event-modal/event-modal.pug
// module id = 689
// module chunks = 1